import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import {
  AfterContentChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { User } from '@sparro/app/core/models/user.model';

import { CompetitionService } from '@sparro/app/core/api/competition/competition.service';
import { UserService } from '@sparro/app/core/api/user/user.service';
import { StudioCompetition } from '@sparro/app/core/models/competition.model';
import { BREAKPOINTS } from '@sparro/app/core/config/constants.config';
import { environment } from '@sparro/env/environment';
import { SelectStudioHostDialogComponent } from '../components/select-studio-host-dialog/select-studio-host-dialog.component';

@Component({
  selector: 'uni-competition-cards-group',
  templateUrl: './competition-cards-group.component.html',
  styleUrls: ['./competition-cards-group.component.scss']
})
export class CompetitionCardsGroupComponent implements OnInit, AfterViewInit, AfterContentChecked {
  @Input() competitions = [];
  @Input() can_edit: boolean = false;
  @Input() can_delete: boolean = false;
  @Input() display: 'grid' | 'breakpoint' = 'grid';
  @Input() footerType: 'two-grid' | 'three-grid' | 'none' | 'organization' = 'two-grid';
  @Input() align: 'start' | 'center' | 'end' = 'start';
  @Input() host: string;
  @Input() showCreate: boolean = false;
  @Input() organization?: string;
  isLoading: boolean = false;

  visibleCompetitions = [];
  current_position = 0;
  limit: number = 0;

  isMobileView: boolean = false;
  user: User;
  hosted: boolean = false;
  responsiveCards: boolean = false;

  @ViewChild('grid', { read: ElementRef }) grid: ElementRef;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public breakpointObserver: BreakpointObserver,
    private userService: UserService,
    private competitionService: CompetitionService,
    private renderer: Renderer2,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    if (this.showCreate && !this.organization) {
      throw new Error('Organization is required');
    }
    this.getAuthUser();
    this.initializeBreakpoints();
    if (this.display === 'breakpoint') {
      this.getCompetitions();
    }
    this.onResize();
  }

  getAuthUser(): void {
    this.userService.userInitialized.subscribe((initialized: boolean) => {
      if (initialized) {
        this.userService.user.subscribe((user: User) => {
          this.user = user;
        });
      }
    });
  }

  initializeBreakpoints(): void {
    this.breakpointObserver.observe([BREAKPOINTS.below.md]).subscribe(result => {
      this.isMobileView = result.breakpoints[BREAKPOINTS.below.md];
    });
  }

  ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewInit(): void {
    // Sets place-content as center by default
    if (this.isMobileView) {
      this.renderer.setStyle(this.grid.nativeElement, 'place-content', 'center');
    } else {
      this.renderer.setStyle(this.grid.nativeElement, 'place-content', this.align);
    }
    this.changeDetectorRef.detectChanges();
    this.responsiveCards = this.grid.nativeElement.offsetWidth<=540;
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    // TODO: change grid-breakpoint from id to class.
    const element = document.getElementById('grid-breakpoint');
    if (element !== null) {
      // console.log(element.offsetWidth);
      const cardLimit = Math.floor(element.offsetWidth / 320);
      this.limit = cardLimit;
      this.getCompetitions();
    }
    this.changeDetectorRef.detectChanges();
    this.responsiveCards = this.grid.nativeElement.offsetWidth<=540;
    // console.log(this.grid.nativeElement.offsetWidth,
    //  this.responsiveCards)
  }

  getCompetitions(): void {
    // console.log(this.limit)
    this.visibleCompetitions = this.competitions.slice(0, this.limit);
    this.changeDetectorRef.detectChanges();
  }

  selectHosting() {
    const dialogRef = this.dialog.open(SelectStudioHostDialogComponent, {
      width: '527px'
    });

    dialogRef.afterClosed().subscribe((response: any) => {
      if (response) {
        this.hosted = response.hosting;
        this.createCompetition();
      }
    });
  }

  createCompetition(): void {
    if (!this.organization) {
      return;
    }
    this.isLoading = true;
    const postData = {
      organization: this.organization,
      hosted: this.hosted
    };

    this.competitionService.createCompetition(postData).subscribe(
      (response: StudioCompetition) => {
        if (response) {
          // console.log(response);
          // this.competitions.push(response);
          const competition_uuid = response.uuid;
          this.isLoading = false;
          const url = `${environment.studioUrl}${competition_uuid}/`;
          window.open(url, '_blank');
        }
      },
      err => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }
}
